/* eslint-disable react/prop-types,no-shadow */
import React from 'react';
import { connect } from 'react-redux';
import { setTeams } from 'store/global/action';
import { updateUsers } from 'views/Setup/Users/flow/action';
import TemplatePermission from './TemplatePermission';
import {
  getUserFolderData,
  getAllUser,
  setSelectedPermissionTeam,
  setPermissionVisible,
  setSelectedUser,
  addPermissionTeam,
  addPermissionUser,
  removeEntityFromSelection,
  updateShareFolderData,
} from '../../../flow/action';
import { getPermissionTeamUsers, getSelectedTeamName } from '../../../flow/reselect';


class EmailTemplatePermission extends React.Component {
  componentDidMount() {
    const { getAllUser } = this.props;
    getAllUser();
  }

    // Todo add team to permission list
    handleDoubleClickTeam = (selectedKeys, teamName) => {
      const { addPermissionTeam } = this.props;
      addPermissionTeam({
        id: selectedKeys,
        name: teamName
      });
    }

    handleDoubleClickUser = (selectedKeys, item) => {
      const { addPermissionUser } = this.props;
      addPermissionUser({
        id: selectedKeys,
        name: item.name,
        team_id: true
      });
    }

    handleTagClose = (itemId, isTeam) => this.props.removeEntityFromSelection({ itemId, isTeam })

    save = () => {
      const {
        updateShareFolderData,
        addedPermissionDepartment,
        addedPermissionUser,
        selectedFolder,
      } = this.props;
      const shareToTeams = addedPermissionDepartment.map(item => item.id);
      const shareToUsers = addedPermissionUser.map(item => item.id);
      updateShareFolderData({
        folderId: selectedFolder.id,
        shareToTeams,
        shareToUsers
      });
    }

    render() {
      const {
        teams,
        setSelectedPermissionTeam,
        setTeams,
        teamUsers,
        isPermissionVisible,
        setPermissionVisible,
        addedPermissionDepartment,
        addedPermissionUser,
        selectedFolder,
        isCurrentUser,
      } = this.props;

      return (
        <TemplatePermission
          teams={teams}
          setSelectedPermissionTeam={setSelectedPermissionTeam}
          setTeams={setTeams}
          teamUsers={teamUsers}
          isPermissionVisible={isPermissionVisible}
          setPermissionVisible={setPermissionVisible}
          addedPermissionDepartment={addedPermissionDepartment}
          addedPermissionUser={addedPermissionUser}
          selectedFolder={selectedFolder}
          isCurrentUser={isCurrentUser}
          handleTagClose={this.handleTagClose}
          save={this.save}
          handleDoubleClickTeam={this.handleDoubleClickTeam}
          handleDoubleClickUser={this.handleDoubleClickUser}
        />
      );
    }
}

const mapStateToProps = ({ global, setup, loginUser }) => {
  const { emailTemplates } = setup;
  return {
    teams: global.settings.teams,
    teamUsers: getPermissionTeamUsers({ emailTemplates }),
    loginUser,
    isSelectTeamDialogVisible: emailTemplates.ui.isSelectTeamDialogVisible,
    isPermissionVisible: emailTemplates.ui.isPermissionVisible,
    selectedUser: emailTemplates.selectedUser,
    selectedTeamName: getSelectedTeamName({ global, emailTemplates }),
    addedPermissionDepartment: emailTemplates.addedPermissionDepartment,
    addedPermissionUser: emailTemplates.addedPermissionUser,
  };
};

const mapDispatchToProps = {
  setTeams,
  getUserFolderData,
  getAllUser,
  updateUsers,
  setSelectedPermissionTeam,
  setPermissionVisible,
  setSelectedUser,
  addPermissionTeam,
  addPermissionUser,
  removeEntityFromSelection,
  updateShareFolderData,
};

export default connect(mapStateToProps, mapDispatchToProps)(EmailTemplatePermission);




// WEBPACK FOOTER //
// ./src/views/email/emailTemplates/component/templatePermissionComponent/emailTemplatePermission.js